import React, { useState, useEffect, useCallback } from 'react'
import Tour from 'reactour'
import { steps } from '../constants/assets/firstSteps.json'
import { useConfigContext } from '../hooks'
import ErrorBoundary from './ErrorBoundary'

const Onboarding = ({ enabled, onLaunch, onFinish }) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  const {
    customerConfig: { customer },
  } = useConfigContext()
  const classList = ['main-menu-page', 'page-switcher']

  const getUpdatedSteps = (steps) => {
    const customerClass =
      customer === 'tracfone' ? 'onboarding-tf' : 'onboarding-st'
    const updatedSteps = steps.map((step) => ({
      selector: step.selector,
      content: () => (
        <div
          className={`tour-content ${step.stepClass || ''} ${customerClass}`}
          dangerouslySetInnerHTML={{ __html: step.content }}
        />
      ),
      position: step.position,
      action: (node) => {
        if (node) {
          node.focus()
        }
      },
    }))
    return updatedSteps
  }

  const currentSteps =
    window.innerWidth <= 770
      ? getUpdatedSteps(steps.isMobile)
      : getUpdatedSteps(steps.isDesktop)

  const darkenBackground = (classes) => {
    classes.map((cl) => {
      const el = document.getElementsByClassName(cl)[0]
      if (el) {
        el.classList.add('darken-overlay')
      }
    })
  }

  const restoreBackground = (classes) => {
    classes.map((cl) => {
      const el = document.getElementsByClassName(cl)[0]
      if (el && el.classList.contains('darken-overlay')) {
        el.classList.remove('darken-overlay')
      }
    })
  }

  useEffect(() => {
    if (enabled && !isOpen) {
      setIsOpen(true)
      darkenBackground(classList)
    }
  }, [enabled, isOpen])

  const handleRequestClose = () => {
    setIsOpen(false)
    restoreBackground(classList)
    onFinish()
  }

  const handleAfterOpen = (target) => {
    if (target) {
      target.focus()
    }
    // Hide prev button on first step
    setTimeout(() => {
      const prevButton = document.querySelector('.reactour__controls button:first-child')
      if (prevButton && currentStep === 0) {
        prevButton.style.display = 'none'
      }
    }, 100)
  }

  useEffect(() => {
    const prevButton = document.querySelector('.reactour__controls button:first-child')
    if (prevButton) {
      prevButton.style.display = currentStep === 0 ? 'none' : 'block'
      if (currentStep !== 0) {
        setTimeout(() => prevButton.focus(), 100)
      }
    }
  }, [currentStep])

  const accentColor = customer === 'tracfone' ? '#012979' : '#000000'

  return (
    <Tour
      steps={currentSteps}
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      onAfterOpen={handleAfterOpen}
      disableInteraction={false}
      disableKeyboardNavigation={false}
      startAt={0}
      goToStep={currentStep}
      getCurrentStep={(step) => setCurrentStep(step)}
      accentColor={accentColor}
      rounded={9}
      showButtons={true}
      showNavigation={false}
      showNavigationNumber={false}
      showNumber={false}
      showCloseButton={false}
      maskSpace={10}
      className="custom-tour"
      prevButton={<span>Back</span>}
      nextButton={<span>Next</span>}
      lastStepNextButton={<span>Next</span>}
    />
  )
}

const WithErrorBoundaryOnboarding = (props) => (
  <ErrorBoundary>
    <Onboarding {...props} />
  </ErrorBoundary>
)

export default WithErrorBoundaryOnboarding
